var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeaderColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 44,
    viewBox: "0 0 232 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.786 34.9521C65.8416 34.9521 65.8416 30.8995 65.8416 30.8995C65.8416 30.8995 65.8416 26.8468 61.786 26.8468C57.7305 26.8468 57.7305 28.6613 57.7305 30.8995C57.7305 33.1377 57.7305 34.9521 61.786 34.9521Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3654 25.6889C67.0003 25.6889 67.0003 21.0574 67.0003 21.0574C67.0003 21.0574 67.0003 16.4258 62.3654 16.4258C57.7305 16.4258 57.7305 18.4994 57.7305 21.0574C57.7305 23.6153 57.7305 25.6889 62.3654 25.6889Z",
    fill: "#819FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_813_496)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8189 3.00098C56.9479 3.00098 61 7.00098 61 13.001V19.001C61 21.5438 59.952 24.0865 58.1158 25.9717C59.786 26.9718 61 28.6104 61 30.249C61 35.499 56.846 38.999 50.6151 38.999H12.1155C9.51924 38.999 9 38.5615 9 36.374V29.001V24.999V14.001C9 8.00098 14.0906 3.00098 20.3215 3.00098H50.8189Z",
    fill: "#CDD9FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9355 29.3759H26.0645C24.0002 29.3759 24 29.8759 24 30.8759C24 31.8758 25.0323 33.3759 31.2258 33.3759H47.7742C53.9677 33.3759 55 31.8759 55 30.8759C55 29.8759 54.9998 29.3759 52.9355 29.3759Z",
    fill: "#6E90FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2608 7.07202H52.7392C57 7.07202 59.5 10.572 59.5 14.4377V17.651C59.5 21.3047 56 25.072 51.7392 25.072H27.2608C22.8035 25.072 19.5 22.3047 19.5 18.651V14.4377C19.5 9.78393 22.8035 7.07202 27.2608 7.07202Z",
    fill: "#527BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2675 22.3995C35.1157 22.3995 38.2353 19.4894 38.2353 15.8995C38.2353 12.3097 35.1157 9.39954 31.2675 9.39954C27.4194 9.39954 24.2998 12.3097 24.2998 15.8995C24.2998 19.4894 27.4194 22.3995 31.2675 22.3995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2779 22.3995C54.1261 22.3995 57.2457 19.4894 57.2457 15.8995C57.2457 12.3097 54.1261 9.39954 50.2779 9.39954C46.4298 9.39954 43.3102 12.3097 43.3102 15.8995C43.3102 19.4894 46.4298 22.3995 50.2779 22.3995Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21425 34.9521C11.2698 34.9521 11.2698 33.1377 11.2698 30.8995C11.2698 28.6613 11.2698 26.8468 7.21425 26.8468C3.1587 26.8468 3.15869 30.8995 3.15869 30.8995C3.15869 30.8995 3.1587 34.9521 7.21425 34.9521Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63492 25.6889C11.2698 25.6889 11.2698 23.6153 11.2698 21.0574V21.0573C11.2698 18.4994 11.2698 16.4258 6.63492 16.4258C2 16.4258 2 21.0574 2 21.0574C2 21.0574 2.00001 25.6889 6.63492 25.6889Z",
    fill: "#819FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_813_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0405 35V7H82.5205C84.4405 7 86.1205 7.29333 87.5605 7.88C89.0005 8.46667 90.1205 9.36 90.9205 10.56C91.7205 11.7333 92.1205 13.2 92.1205 14.96C92.1205 16.0533 91.8405 17.0667 91.2805 18C90.7472 18.9067 89.9872 19.6933 89.0005 20.36C90.3072 21.0267 91.3072 21.92 92.0005 23.04C92.7205 24.1333 93.0805 25.4533 93.0805 27C93.0805 28.7067 92.6938 30.16 91.9205 31.36C91.1472 32.56 90.0672 33.4667 88.6805 34.08C87.2938 34.6933 85.6672 35 83.8005 35H73.0405ZM78.4005 30.16H83.2805C84.5872 30.16 85.6138 29.84 86.3605 29.2C87.1072 28.5333 87.4805 27.6533 87.4805 26.56C87.4805 25.4133 87.0672 24.52 86.2405 23.88C85.4138 23.2133 84.2805 22.88 82.8405 22.88H78.4005V30.16ZM78.4005 18.4H82.6405C83.8405 18.4 84.7872 18.0933 85.4805 17.48C86.1738 16.8667 86.5205 16 86.5205 14.88C86.5205 13.76 86.1338 12.8933 85.3605 12.28C84.5872 11.6667 83.5338 11.36 82.2005 11.36H78.4005V18.4ZM105.173 35.48C103.146 35.48 101.333 35.04 99.7327 34.16C98.1593 33.2533 96.9193 32.0133 96.0127 30.44C95.1327 28.8667 94.6927 27.0533 94.6927 25C94.6927 22.9467 95.1327 21.1333 96.0127 19.56C96.8927 17.9867 98.1193 16.76 99.6927 15.88C101.266 14.9733 103.066 14.52 105.093 14.52C107.146 14.52 108.959 14.9733 110.533 15.88C112.106 16.76 113.333 17.9867 114.213 19.56C115.093 21.1333 115.533 22.9467 115.533 25C115.533 27.0533 115.093 28.8667 114.213 30.44C113.333 32.0133 112.106 33.2533 110.533 34.16C108.986 35.04 107.199 35.48 105.173 35.48ZM105.173 30.6C106.159 30.6 107.026 30.36 107.773 29.88C108.519 29.4 109.093 28.7467 109.493 27.92C109.919 27.0667 110.133 26.0933 110.133 25C110.133 23.9067 109.919 22.9467 109.493 22.12C109.066 21.2667 108.466 20.6 107.693 20.12C106.946 19.64 106.079 19.4 105.093 19.4C104.133 19.4 103.266 19.64 102.493 20.12C101.746 20.6 101.159 21.2667 100.733 22.12C100.306 22.9467 100.093 23.9067 100.093 25C100.093 26.0933 100.306 27.0667 100.733 27.92C101.159 28.7467 101.759 29.4 102.533 29.88C103.306 30.36 104.186 30.6 105.173 30.6ZM126.255 35.48C124.042 35.48 122.362 34.9333 121.215 33.84C120.095 32.7467 119.535 31.1867 119.535 29.16V8.76H124.815V28C124.815 28.8533 125.002 29.5067 125.375 29.96C125.748 30.3867 126.295 30.6 127.015 30.6C127.282 30.6 127.575 30.5467 127.895 30.44C128.215 30.3067 128.548 30.12 128.895 29.88L130.735 33.84C130.095 34.32 129.375 34.7067 128.575 35C127.802 35.32 127.028 35.48 126.255 35.48ZM116.295 19.48V15H129.815V19.48H116.295ZM132.869 35V30.96C132.869 30.1867 133.109 29.3333 133.589 28.4C134.069 27.4667 134.735 26.5333 135.589 25.6C136.442 24.6667 137.442 23.8 138.589 23L142.829 19.96C143.415 19.56 143.962 19.1067 144.469 18.6C145.002 18.0933 145.429 17.5467 145.749 16.96C146.095 16.3467 146.269 15.76 146.269 15.2C146.269 14.5067 146.095 13.88 145.749 13.32C145.429 12.76 144.949 12.32 144.309 12C143.669 11.68 142.882 11.52 141.949 11.52C141.149 11.52 140.429 11.68 139.789 12C139.175 12.32 138.669 12.7467 138.269 13.28C137.869 13.8133 137.589 14.3867 137.429 15L131.789 14.04C132.055 12.7067 132.629 11.4667 133.509 10.32C134.389 9.17333 135.535 8.25333 136.949 7.56C138.389 6.84 140.015 6.48 141.829 6.48C143.909 6.48 145.695 6.85333 147.189 7.6C148.682 8.34667 149.829 9.37333 150.629 10.68C151.455 11.96 151.869 13.4533 151.869 15.16C151.869 16.8933 151.389 18.44 150.429 19.8C149.495 21.1333 148.202 22.3867 146.549 23.56L142.749 26.32C141.975 26.8533 141.309 27.44 140.749 28.08C140.189 28.72 139.762 29.4267 139.469 30.2H152.229V35H132.869ZM155.273 35V7H160.553V31.28L160.273 35H155.273ZM166.593 35.48C164.913 35.48 163.486 35.0533 162.313 34.2C161.166 33.3467 160.286 32.1333 159.673 30.56C159.059 28.9867 158.753 27.1333 158.753 25C158.753 22.84 159.059 20.9867 159.673 19.44C160.286 17.8667 161.166 16.6533 162.313 15.8C163.486 14.9467 164.913 14.52 166.593 14.52C168.433 14.52 170.019 14.9467 171.353 15.8C172.713 16.6533 173.766 17.8667 174.513 19.44C175.259 20.9867 175.633 22.84 175.633 25C175.633 27.1333 175.259 28.9867 174.513 30.56C173.766 32.1333 172.713 33.3467 171.353 34.2C170.019 35.0533 168.433 35.48 166.593 35.48ZM165.233 30.64C166.193 30.64 167.033 30.4 167.753 29.92C168.499 29.44 169.086 28.7733 169.513 27.92C169.939 27.0667 170.153 26.0933 170.153 25C170.153 23.9067 169.939 22.9333 169.513 22.08C169.113 21.2267 168.539 20.5733 167.793 20.12C167.073 19.64 166.233 19.4 165.273 19.4C164.366 19.4 163.553 19.64 162.833 20.12C162.113 20.6 161.553 21.2667 161.153 22.12C160.753 22.9467 160.553 23.9067 160.553 25C160.553 26.0933 160.753 27.0667 161.153 27.92C161.553 28.7733 162.099 29.44 162.793 29.92C163.513 30.4 164.326 30.64 165.233 30.64ZM178.861 35V7H184.821L192.981 19.08L201.141 7H207.061V35H201.621V15.56L192.981 28.28L184.341 15.6V35H178.861ZM220.438 35.48C218.464 35.48 216.718 35.04 215.198 34.16C213.678 33.2533 212.478 32.0133 211.598 30.44C210.744 28.8667 210.318 27.0533 210.318 25C210.318 22.9467 210.758 21.1333 211.638 19.56C212.544 17.9867 213.771 16.76 215.318 15.88C216.891 14.9733 218.691 14.52 220.718 14.52C222.478 14.52 224.091 14.9867 225.558 15.92C227.051 16.8267 228.238 18.1733 229.118 19.96C230.024 21.72 230.478 23.8667 230.478 26.4H215.318L215.798 25.92C215.798 26.9067 216.038 27.7733 216.518 28.52C217.024 29.24 217.664 29.8 218.438 30.2C219.238 30.5733 220.091 30.76 220.998 30.76C222.091 30.76 222.984 30.5333 223.678 30.08C224.371 29.6 224.904 28.9867 225.278 28.24L229.998 30.08C229.438 31.2 228.704 32.1733 227.798 33C226.918 33.8 225.864 34.4133 224.638 34.84C223.411 35.2667 222.011 35.48 220.438 35.48ZM216.078 22.96L215.598 22.48H225.238L224.798 22.96C224.798 22 224.571 21.24 224.118 20.68C223.664 20.0933 223.104 19.6667 222.438 19.4C221.798 19.1333 221.171 19 220.558 19C219.944 19 219.291 19.1333 218.598 19.4C217.904 19.6667 217.304 20.0933 216.798 20.68C216.318 21.24 216.078 22 216.078 22.96Z",
    fill: "#2E60FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_813_496",
    x: 55.7305,
    y: 16.4258,
    width: 11.27,
    height: 22.5263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_813_496",
    x: 7,
    y: 3.00098,
    width: 54,
    height: 39.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_813_496",
    x: 4,
    y: 0.000976562,
    width: 60,
    height: 43.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_813_496",
    x: 24,
    y: 29.3759,
    width: 31,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "shape",
    result: "effect1_innerShadow_813_496"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_813_496",
    x: 17.5,
    y: 3.07202,
    width: 46,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72 0 0 0 0 0.786316 0 0 0 0 1 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-lighter",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_813_496",
    x: 22.2998,
    y: 7.39954,
    width: 36.9458,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_813_496",
    x: 0,
    y: 16.4258,
    width: 11.27,
    height: 22.5263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_813_496",
    x: 70.0405,
    y: 6.48001,
    width: 160.437,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_813_496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_813_496",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeaderColor);
export default __webpack_public_path__ + "static/media/logo-header-color.6beb4f4e0745dac7a2107746f878a042.svg";
export { ForwardRef as ReactComponent };